import { __extends, __rest, __assign } from 'tslib';
import { classNames, liveAnnounce, validateChildTypes } from 'uitk-react-utils';
import { useLocalization } from '@shared-ui/localization-context';
import { createElement, Component, Fragment } from 'react';
import { UitkInput } from 'uitk-react-input';
import { UitkEmptyState } from 'uitk-react-empty-state';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkText } from 'uitk-react-text';
import { UitkTextSkeleton, UitkIconSkeleton } from 'uitk-react-skeleton';
import { UitkButton } from 'uitk-react-button';
import { UitkToolbarContainer, UitkToolbarAction, ToolbarType, UitkToolbarContent } from 'uitk-react-toolbar';

var UitkTypeaheadInput = /** @class */ (function (_super) {
    __extends(UitkTypeaheadInput, _super);
    function UitkTypeaheadInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkTypeaheadInput.prototype.render = function () {
        var _a = this.props, autoCapitalize = _a.autoCapitalize, autoComplete = _a.autoComplete, autoCorrect = _a.autoCorrect, className = _a.className, spellCheck = _a.spellCheck, placeholder = _a.placeholder, props = __rest(_a, ["autoCapitalize", "autoComplete", "autoCorrect", "className", "spellCheck", "placeholder"]);
        var cssClassNames = classNames('uitk-typeahead-input', className);
        return (createElement(UitkInput, __assign({}, props, { autoCapitalize: "off", autoComplete: "off", autoCorrect: "off", className: cssClassNames, type: "text", spellCheck: false, placeholder: placeholder })));
    };
    UitkTypeaheadInput.displayName = 'UitkTypeaheadInput';
    return UitkTypeaheadInput;
}(Component));

// To be converted into a UitkMark
var POWERED_BY_GOOGLE_LOGO = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAASCAYAAAC0PldrAAAIHElEQVR4Ae3ZBXDbWB7H8efglpm' +
    'ZGW0HlhzJDpSZmZkZ3W3s2DpmZmbmKx0zM/NdoGhotxTf9x9LHY027paW85v5bBRQopn32weqasqzk5Jw7BE9nHijHo5/Rw/HfqaHYl/' +
    'keldZ8GJ7qBeqZ/6PNGlPUT5DeVKNqkyc18PJ6VDPtfEfnvUJz0dmpbwfmzMW6k5YFy96pBRTkCnL4MUDiy94oS0F+ZVZlD/5qxLLfNF' +
    'kz0D0fBtfKOkpCcffrFfG6vVQ4hDUc6ypQLdDFmMdMiWIcjywaOHEB8zynPEFa1pCOWnHLw2Bej5oKtDzqEC+cGyoWZ5YaTDeGer57r4' +
    'LRPLRCi40liy0QR4eVB5CG2QhU3KQneG+TM/qQhvk424L1Bwt73P22d9QoFD8bVB3KxVUWTX+gqW1mvvLtbr7Z7V+z6frNM/UlFIuKAD' +
    '83I2v5y69eiL3y9dPZP/s2tdyPn39ZN7UVEq5oCz8x+WvjC/SQrEv8/u/z/O9siSUKNfC8agWSbrRaIH+p3lH1Pg976jxe38gz8JzzLM' +
    '/g2QhpmIuIjCwB/0cg6HjGAxEsQQtIZmCtbBnLbY4BngZptkGaQmiMHAUhbCyEJMxCxGsh6QFltruOwIv7BmEfTAQwWwsvYMCTcMqGKa' +
    't6AJJCXYjD1ZcWIdZsEdK8K50gZLroez4+l4G8j1PURlfAJWaMye7Vvd+otbvTVVr7hvVmvc/ci0YyNdAidTHVPa1EzmfuH4iN0WBbnD' +
    '9H7lu8PXc10CJYDCVxanvffI8nAZvloQTNenZMXYt/YyJ5Y3tgar9nkCt5n2y4Tl073+5TprPEIYSknW2ARpkWosQOkFSiijK0BtuHME' +
    '2ZGMMDLSDpBMMU29bYaIYBxfW4wBGojcmw8BIWM8Vwjq40QMubMR+231TYGAYJN1QhVUYgEHYgMgdFCiCBeiLYdiJI2iO9og6St4XBgZ' +
    'nKpAWjm2AsmNZO+E8jdlnqzrdvS49aO4fndWLekDVlbmHMoB/MQewAorCrDML86P6E816QD35lbyhzER/SZcouwJKq0oskd9PSX9aVnm' +
    '5F1RJVbKQr13IVKCU251b7Xf/WwpcqxfMkVnngm9MW+sZ6gJeD24N1BHkwUouDmI28hDGBNjTDwZGIR9hFEOiYyu2YRIkY1GFhzAABvr' +
    'CnpVYbyvQAeTAyiBHKa2sNUnmY5/jvnwcvYMCbXDMmG1QBR2SJdhu+5l52NXYMsqA7EsXI/5OKBvEhnMKK7LwtePpgYy9HIpB+lbDIGm' +
    'FbihLTcAzs6FAuueDUJTkW0hdO5XrhrJc/1reTPk6BfsgZMY7iZS/KumFsmihxIFMBaoNeHxmiT/6H5+7Y41esJcl7K/pmdD9N64n4tZ' +
    'ALYQzs7EDvTMMmgtBW7GWYyUk26DDj/1wYYHt+z7bUhixMXDMVqDFznG5zX1HIdmDGbDnTvdAGpzZhGWO/2n6ojnCKIIzDNClwQ1LRmU' +
    '8ETCS3aEysU5r7FHmQckAyUD9sWJgPpSlNlA4SL7O0vJNqGtfz/6bFKX+SyofyvLk1/IGNcxAX8v9JpS8QpDfX/Ha+nwoC8vplIwFYq/' +
    'TUFbN+w9Zxqr93vpq3fOFWn/BJFlioYQ1UEvgzHxsRQ8Y6NdIgY6jDBI3wugGA53QxVa+IAogeQwR9EB3h27IVGwfqjLc1xWSnZgNZ5b' +
    'dQYECcGabrcgubMUCPIZjtztQWPsOZpjvPRq52A7KSatKTpV3QfxcXenL61tASUFk8M7q7gIoiywl6UF1fwBKCmLONAVQlhsn8+aYX/8' +
    'AVEll4pQ8h7x7grLIRj9TgWo0z8Ppsnqv1eqeyP98hX2hZClrrEDH0QpWWuIYJiMbQcx1TNWjYWCQbY8TwQbshJXdWI+obdPdEwbGwJ7' +
    'ipylQH2vZdN5nK9AMHEVzx1JUeQcF2uVY+rojimJYGY8q7MdEZIy8MGTwfmHuhf5JkTbJex/fyxJdtcpLDzNob5JNrbn/mQMl2ECvNpe' +
    'Kn1sDV6MVjGEz/U9zWSmFYuO82tzr/PzK6fy+UFdP5o6hNP9M742ySyFL1VJrDxSIXu4NJUunvAXPVCApCfufP5p7rg1y2pMZkeswX/u' +
    '+zIawF0jtwyOmvThiK5UXBhbDgwkIY7mjVKthoBRWymE0MngLbXsrN+bbS5WhQC4sRggVjvtGQ9IWQexGMR7BfjxxBwV6AptRgBIcxU7' +
    'kwkoODiOCtrhtZOZhkD52m3/KiFGs+VCAdYT3fsicAer5WIcU4DGghPzcta/nfKjhFPa13HrUybW5fBlQQk5hWmXi/fL3rNnuTk5hdX6' +
    'Pl79/wTwNXrJOYbIXOh9w98atgVqAx7EPx7AUHWDPSGy2la0MOY38zCp0gZWuWNXIbJONAPYhhK0YDSsTocGZbJRmuM9KJ6zAceyHD48' +
    '9zYyxCGMwGYdts24LOLMWi3DHkQ0sg/QqWU5KwvEf4HPMDHseDcc6QTnJUiH7EGajz8g7GPYiH2EWKoOyk/c9vAeax6zzGcryAz5+5Pr' +
    'J7DIoO37QxTufhRT0C+zLvst11FrC5JQG5f7IrJd5Pjzzx56Pzh4CJc76CnryHugVPMe3OcqfYTkLymkMCpk30RnTlG62jfQLIr5gKkf' +
    '+wVY29lAWWULTM2HsMah70VSgu888bIULL4hw2pqRPhEmfiMbadmbyWzE/utqSSj2nznBVB7UvWgq0N2lLSIYhxdOWL5k+Xzq/it2mdc' +
    'GAah7ZV00eQlgxvFRpNfJeyc+Bn2RK32h7sf/AesqcHB02e65AAAAAElFTkSuQmCC';

var UitkTypeaheadAttribution = function (props) {
    var results = props.results;
    var showLogo = function (typeaheadResults) {
        switch (typeaheadResults.type) {
            case "categorized":
                return showGoogleForCategorizedResults(typeaheadResults.items);
            case "uncategorized":
                return showGoogleForUnCategorizedResults(typeaheadResults.items);
        }
    };
    var showGoogleForCategorizedResults = function (typeaheadResults) {
        return typeaheadResults.some(function (item) {
            return showGoogleLogo(item.typeaheadResults);
        });
    };
    var showGoogleForUnCategorizedResults = function (typeaheadResults) {
        return showGoogleLogo(typeaheadResults);
    };
    var showGoogleLogo = function (typeaheadResults) { return typeaheadResults.some(function (result) {
        var key = 'category';
        return result.data && result.data[key] && result.data[key] === 'GOOGLEMAPS';
    }); };
    return showLogo(results) ? (createElement("div", { className: "uitk-typeahead-google-logo" },
        createElement("img", { src: POWERED_BY_GOOGLE_LOGO, alt: "Powered by Google Logo" }))) : null;
};

var UitkTypeaheadButton = /** @class */ (function (_super) {
    __extends(UitkTypeaheadButton, _super);
    function UitkTypeaheadButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkTypeaheadButton.prototype.render = function () {
        return (createElement(UitkButton, __assign({}, this.props, { className: "uitk-button-typeahead uitk-type-left " + this.props.className, isFullWidth: true })));
    };
    UitkTypeaheadButton.displayName = 'UitkTypeaheadButton';
    return UitkTypeaheadButton;
}(Component));

var UitkTypeaheadResultItem = /** @class */ (function (_super) {
    __extends(UitkTypeaheadResultItem, _super);
    function UitkTypeaheadResultItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    UitkTypeaheadResultItem.prototype.render = function () {
        var _a = this.props, activeSuggestion = _a.activeSuggestion, className = _a.className, disabled = _a.disabled, icon = _a.icon, index = _a.index, name = _a.name, stid = _a.stid, sanitized = _a.sanitized, subtext = _a.subtext;
        /*const cssClassNames = subtext
          ? classNames('uitk-typeahead-result-item has-subtext', className)
          : classNames('uitk-typeahead-result-item', className);*/
        var cssClassNames = classNames(className, subtext
            ? 'uitk-typeahead-result-item has-subtext'
            : 'uitk-typeahead-result-item', activeSuggestion === true ? 'uitk-typeahead-result-item-hover' : '');
        if (activeSuggestion === true) {
            liveAnnounce("" + this.props.value);
        }
        var iconContent;
        var contentFirstLine;
        var contentSecondLine;
        if (disabled) {
            contentFirstLine = createElement(UitkTextSkeleton, null);
            iconContent = createElement(UitkIconSkeleton, null);
        }
        else if (sanitized) {
            contentFirstLine = createElement("span", null, name);
            iconContent = createElement(UitkIcon, { name: icon, size: UitkIconSize.SMALL });
        }
        else {
            contentFirstLine = (createElement("div", { className: "truncate" },
                createElement("span", { dangerouslySetInnerHTML: { __html: name } })));
            if (subtext) {
                contentSecondLine = (createElement("div", { className: "is-subText truncate", dangerouslySetInnerHTML: { __html: subtext } }));
            }
            iconContent = createElement(UitkIcon, { name: icon, size: UitkIconSize.SMALL });
        }
        return (createElement("li", { className: cssClassNames, "data-stid": stid && stid + "-result-item", "data-index": index },
            createElement(UitkTypeaheadButton, { "data-stid": stid && stid + "-result-item-button", disabled: disabled, onClick: this.handleClick, className: subtext ? "has-subtext" : '' },
                iconContent,
                createElement("div", { className: "uitk-typeahead-button-label uitk-type-medium uitk-type-300 truncate" },
                    contentFirstLine,
                    contentSecondLine))));
    };
    UitkTypeaheadResultItem.prototype.handleClick = function (event) {
        var props = this.props;
        this.props.onResultItemSelect(props.value, props.data);
    };
    UitkTypeaheadResultItem.displayName = 'UitkTypeaheadResultItem';
    return UitkTypeaheadResultItem;
}(Component));

var UitkTypeaheadResultTitle = /** @class */ (function (_super) {
    __extends(UitkTypeaheadResultTitle, _super);
    function UitkTypeaheadResultTitle(props) {
        return _super.call(this, props) || this;
    }
    UitkTypeaheadResultTitle.prototype.render = function () {
        var _a = this.props, className = _a.className, name = _a.name;
        var cssClassNames = classNames('uitk-typeahead-result-title', className);
        return (createElement("li", { className: cssClassNames },
            createElement("div", { className: "uitk-typeahead-result-title-label uitk-type-300 truncate" }, name)));
    };
    UitkTypeaheadResultTitle.displayName = 'UitkTypeaheadResultTitle';
    return UitkTypeaheadResultTitle;
}(Component));

var UitkTypeaheadResults = function (props) {
    var l10n = useLocalization();
    return createElement(TypeaheadResults, __assign({ l10n: l10n }, props));
};
var TypeaheadResults = /** @class */ (function (_super) {
    __extends(TypeaheadResults, _super);
    function TypeaheadResults(props) {
        return _super.call(this, props) || this;
    }
    TypeaheadResults.prototype.render = function () {
        var _a = this.props, activeSuggestion = _a.activeSuggestion, allowExactMatch = _a.allowExactMatch, listTitle = _a.listTitle, l10n = _a.l10n, onResultItemSelect = _a.onResultItemSelect, results = _a.results, searchTerm = _a.searchTerm, stid = _a.stid, emptyResultPlaceholder = _a.emptyResultPlaceholder;
        var getSizeOfTypeaheadResults = function (typeaheadResults) {
            switch (typeaheadResults.type) {
                case 'categorized':
                    return typeaheadResults.items.flatMap(function (item) { return item.typeaheadResults; }).length;
                case 'uncategorized':
                    return typeaheadResults.length;
            }
        };
        var resultsLen = getSizeOfTypeaheadResults(results);
        if (!results || results.items.length === 0) {
            return emptyResultPlaceholder ? (createElement(UitkEmptyState, { className: "uitk-typeahead-empty-state" },
                createElement(UitkIcon, { name: "search", size: UitkIconSize.LARGE }),
                createElement(UitkText, null, emptyResultPlaceholder))) : null;
        }
        var showUnCategorizedResults = function (typeaheadResults) {
            return (typeaheadResults &&
                typeaheadResults.map(function (result, index) { return (createElement(Fragment, { key: index },
                    listTitle && createElement(UitkTypeaheadResultTitle, { name: result.title }),
                    createElement(UitkTypeaheadResultItem, { className: result.data && result.isChild ? 'is-child' : '', data: result.data, disabled: result.disabled, key: index, index: index, icon: result.icon, name: result.name, onResultItemSelect: onResultItemSelect, stid: stid, value: result.value, subtext: result.subtext, activeSuggestion: activeSuggestion !== -1 && activeSuggestion === index }))); }));
        };
        var showCategorizedResults = function (categorizedResults) {
            return categorizedResults &&
                categorizedResults.map(function (category) { return (createElement(Fragment, { key: category.heading },
                    createElement(UitkTypeaheadResultTitle, { name: category.heading }),
                    category.typeaheadResults &&
                        category.typeaheadResults.map(function (item, index) {
                            var _a;
                            return (createElement(UitkTypeaheadResultItem, { className: item.data && item.isChild ? 'is-child' : '', data: item.data, disabled: item.disabled, key: index, index: index, icon: item.icon, name: item.name, onResultItemSelect: onResultItemSelect, stid: stid, value: item.value, subtext: item.subtext, activeSuggestion: activeSuggestion !== -1 && activeSuggestion === ((_a = item.data) === null || _a === void 0 ? void 0 : _a.index) }));
                        }))); });
        };
        var showResults = function (resultsDropdown) {
            switch (resultsDropdown.type) {
                case "categorized":
                    return showCategorizedResults(resultsDropdown.items);
                case "uncategorized":
                    return showUnCategorizedResults(resultsDropdown.items);
            }
        };
        return (createElement(Fragment, null,
            createElement("ul", { className: "uitk-typeahead-results no-bullet", "data-stid": stid && stid + "-results" },
                showResults(results),
                allowExactMatch && searchTerm && (createElement(UitkTypeaheadResultItem, { icon: "search", name: l10n.formatText('typeahead.searchFor', [searchTerm]), onResultItemSelect: onResultItemSelect, index: resultsLen, stid: stid, value: searchTerm, sanitized: true, activeSuggestion: activeSuggestion !== -1 && activeSuggestion === resultsLen
                        ? true
                        : false }))),
            createElement(UitkTypeaheadAttribution, { results: results })));
    };
    return TypeaheadResults;
}(Component));

var TypeaheadToolbarVersion;
(function (TypeaheadToolbarVersion) {
    TypeaheadToolbarVersion["V1"] = "v1";
    TypeaheadToolbarVersion["V2"] = "v2";
})(TypeaheadToolbarVersion || (TypeaheadToolbarVersion = {}));
var UitkTypeaheadToolbar = /** @class */ (function (_super) {
    __extends(UitkTypeaheadToolbar, _super);
    function UitkTypeaheadToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkTypeaheadToolbar.prototype.render = function () {
        var _a = this.props, action = _a.action, analytics = _a.analytics, buttonRef = _a.buttonRef, children = _a.children, iconLabel = _a.iconLabel, id = _a.id, renderType = _a.renderType, toolbarVersion = _a.toolbarVersion;
        validateChildTypes(children, [UitkTypeaheadInput], this.constructor.name);
        var containerCssClassNames = classNames('uitk-typeahead-toolbar', "uitk-typeahead-toolbar-" + toolbarVersion);
        var contentCssClassNames = classNames('uitk-typeahead-toolbar-field', "toolbar-content-" + toolbarVersion);
        return (createElement(UitkToolbarContainer, { className: containerCssClassNames },
            renderType !== 'menu' && (createElement(UitkToolbarAction, { action: action, analytics: analytics, buttonRef: buttonRef, iconLabel: iconLabel, type: ToolbarType.CLOSE, id: id })),
            createElement(UitkToolbarContent, { className: contentCssClassNames }, this.props.children)));
    };
    UitkTypeaheadToolbar.displayName = 'UitkTypeaheadToolbar';
    return UitkTypeaheadToolbar;
}(Component));

export { TypeaheadToolbarVersion as T, UitkTypeaheadInput as U, UitkTypeaheadAttribution as a, UitkTypeaheadResults as b, UitkTypeaheadResultItem as c, UitkTypeaheadResultTitle as d, UitkTypeaheadToolbar as e };
